import { render } from "./react_button.vue?vue&type=template&id=5676d1ad"
import script from "./react_button.js?vue&type=script&lang=js&external"
export * from "./react_button.js?vue&type=script&lang=js&external"

import "./react_button.vue?vue&type=style&index=0&id=5676d1ad&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__